import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectModelsByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      diagramSnapshotSelector(projectId),
      (project, diagram) =>
        project && diagram
          ? Object.fromEntries(
              Object.entries(project.modelsById).filter(
                ([id]) => !diagram.model.modelData.deletedModelIds?.includes(id)
              )
            )
          : {}
    )
);
